import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const UserIcon = ({
  className,
  color,
  containerColor,
  containerSize,
  onClick,
  round,
  size,
}) => (
  <WithIconRounded
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    round={round}
  >
    <svg width={size} height={size} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.99996 18.6459C4.39746 18.6459 0.666626 14.6776 0.666626 9.78216C0.666626 4.8867 4.39746 0.918396 8.99996 0.918396C13.6025 0.918396 17.3333 4.8867 17.3333 9.78216C17.3333 14.6776 13.6025 18.6459 8.99996 18.6459ZM4.84413 15.3273C6.02375 16.3304 7.48969 16.8757 8.99996 16.8732C10.6416 16.8732 12.1441 16.2421 13.3058 15.1962C12.7631 14.6038 12.1142 14.1333 11.3975 13.8123C10.6808 13.4914 9.9109 13.3266 9.13329 13.3277C8.32712 13.3267 7.52955 13.5039 6.79118 13.8482C6.05282 14.1924 5.38978 14.6961 4.84413 15.3273ZM3.67996 14.0545C4.38034 13.2639 5.22552 12.6343 6.16341 12.2044C7.1013 11.7745 8.11203 11.5535 9.13329 11.5549C10.118 11.5536 11.0933 11.7591 12.0031 12.1598C12.9129 12.5604 13.7393 13.1483 14.435 13.8896C15.1484 12.8217 15.5697 11.5643 15.6521 10.2572C15.7345 8.95002 15.4749 7.64412 14.902 6.48436C14.3291 5.3246 13.4654 4.35632 12.4066 3.68694C11.3478 3.01757 10.1354 2.67328 8.9038 2.69226C7.67223 2.71124 6.46968 3.09275 5.42956 3.79447C4.38944 4.49619 3.55243 5.49068 3.01137 6.66761C2.47031 7.84454 2.24637 9.1579 2.36439 10.462C2.48241 11.766 2.93777 13.0098 3.67996 14.0554V14.0545ZM8.99996 10.6685C8.1159 10.6685 7.26806 10.295 6.64294 9.63008C6.01782 8.96517 5.66663 8.06336 5.66663 7.12303C5.66663 6.18271 6.01782 5.28089 6.64294 4.61598C7.26806 3.95107 8.1159 3.57753 8.99996 3.57753C9.88402 3.57753 10.7319 3.95107 11.357 4.61598C11.9821 5.28089 12.3333 6.18271 12.3333 7.12303C12.3333 8.06336 11.9821 8.96517 11.357 9.63008C10.7319 10.295 9.88402 10.6685 8.99996 10.6685ZM8.99996 8.89579C9.44199 8.89579 9.86591 8.70901 10.1785 8.37656C10.491 8.0441 10.6666 7.5932 10.6666 7.12303C10.6666 6.65287 10.491 6.20196 10.1785 5.86951C9.86591 5.53705 9.44199 5.35028 8.99996 5.35028C8.55793 5.35028 8.13401 5.53705 7.82145 5.86951C7.50889 6.20196 7.33329 6.65287 7.33329 7.12303C7.33329 7.5932 7.50889 8.0441 7.82145 8.37656C8.13401 8.70901 8.55793 8.89579 8.99996 8.89579Z" fill={color} />
    </svg>
  </WithIconRounded>
);

UserIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  onClick: PropTypes.func,
  round: PropTypes.bool,
  size: PropTypes.number,
};

UserIcon.defaultProps = {
  className: 'k-ds-bg-color-light-grey-300',
  color: '#949BA8',
  containerColor: null,
  containerSize: 40,
  onClick: null,
  round: false,
  size: 16,
};

export default UserIcon;
